/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SiteLoader from '../layout/site-loader';
import PageTitle from '../common/page-title/index';
import HomePageCarousel from '../common/home/user-home-page-carousel';
import PpcCarousel from '../common/home/carousels/ppc-carousel';
import TradeCarousel from '../common/home/carousels/trade-carousel';
import BrandCarousel from '../common/home/carousels/brand-carousel';
import PorCarousel from '../common/home/carousels/por-carousel';
import EverythingElseCarousel from '../common/home/carousels/everything-else-carousel';

import { getHomePage } from '../../actions/home';
import { getLatestNews } from '../../actions/latest-news';
import { getBrandsUser } from '../../actions/brands-user';
import { getPorDeals } from '../../actions/por-deals';

import './styles.css';
import { checkPermission } from '../common/guards/can';

class HomePage extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getHomePage());
    dispatch(getLatestNews());
    dispatch(getBrandsUser());
    dispatch(getPorDeals());
  }

  render() {
    const {
      profileLoaded, carousels, loading, carouselSpeed
    } = this.props;

    if (!profileLoaded || loading) {
      return <SiteLoader/>;
    }

    return (
      <div className='user-home-page'>
        <PageTitle pageTitle='Home'/>
        {profileLoaded && (
          <div>
            <div className="home-slide user-home-page-slide user-inner-container">
              <HomePageCarousel carousels={carousels} carouselSpeed={carouselSpeed} isRedButton />
            </div>
            <div className="home-page-spacer ppc-carousel">
              <PpcCarousel />
            </div>
            <div className="home-page-spacer">
              <TradeCarousel />
            </div>
            <div className="home-page-spacer">
              <BrandCarousel />
            </div>
            {checkPermission('view', 'por_page') && (
              <div className="home-page-spacer">
                <PorCarousel />
              </div>
            )}
            <div className="home-page-spacer">
              <EverythingElseCarousel />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  showPersonalRewardsSettings: state.viewConfig.showPersonalRewardsSettings,
  profile: state.viewConfig.profile,
  profileLoaded: state.viewConfig.loaded,
  carousels: state.home.home_carousels,
  loading: state.home.fetching && !state.home.fetched,
  carouselSpeed: state.home.carousel_speed,
});

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/home/home-page.jsx